import { render, staticRenderFns } from "./orderCheck.vue?vue&type=template&id=613e786c&scoped=true&"
import script from "./orderCheck.vue?vue&type=script&lang=js&"
export * from "./orderCheck.vue?vue&type=script&lang=js&"
import style0 from "./orderCheck.vue?vue&type=style&index=0&id=613e786c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613e786c",
  null
  
)

export default component.exports